// =============================================================================
// Member portal — Bookings tabs + master/detail selection.
// Progressive enhancement: without JS the default tab's rows and the first
// detail panel are visible (server-rendered), so the page is never blank.
// =============================================================================

export function initMember(root = document) {
  root
    .querySelectorAll("[data-wfc-bookings]:not([data-member-bound])")
    .forEach((page) => {
      page.setAttribute("data-member-bound", "");

      const tabs = Array.from(page.querySelectorAll("[data-bk-tab]"));
      const rows = Array.from(page.querySelectorAll("[data-booking-id]"));
      const details = Array.from(
        page.querySelectorAll("[data-booking-detail]"),
      );
      const empties = Array.from(page.querySelectorAll("[data-tab-empty]"));

      const selectBooking = (id) => {
        rows.forEach((r) =>
          r.classList.toggle("is-active", r.dataset.bookingId === id),
        );
        details.forEach((d) => {
          d.hidden = d.dataset.bookingDetail !== id;
        });
      };

      const showTab = (name) => {
        tabs.forEach((t) => {
          const on = t.dataset.bkTab === name;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", String(on));
        });
        rows.forEach((r) => {
          r.hidden = r.dataset.tab !== name;
        });
        empties.forEach((e) => {
          e.hidden = e.dataset.tabEmpty !== name;
        });
        const firstVisible = rows.find((r) => !r.hidden);
        if (firstVisible) {
          selectBooking(firstVisible.dataset.bookingId);
        } else {
          rows.forEach((r) => r.classList.remove("is-active"));
          details.forEach((d) => {
            d.hidden = true;
          });
        }
      };

      tabs.forEach((t, i) => {
        t.addEventListener("click", () => showTab(t.dataset.bkTab));
        t.addEventListener("keydown", (e) => {
          if (e.key === "ArrowRight") {
            e.preventDefault();
            tabs[(i + 1) % tabs.length].focus();
            tabs[(i + 1) % tabs.length].click();
          }
          if (e.key === "ArrowLeft") {
            e.preventDefault();
            tabs[(i - 1 + tabs.length) % tabs.length].focus();
            tabs[(i - 1 + tabs.length) % tabs.length].click();
          }
        });
      });

      rows.forEach((r) => {
        r.addEventListener("click", (e) => {
          e.preventDefault();
          selectBooking(r.dataset.bookingId);
        });
      });

      // Reassert the server-rendered active tab so list + detail are consistent.
      const activeTab =
        tabs.find((t) => t.classList.contains("is-active")) || tabs[0];
      if (activeTab) showTab(activeTab.dataset.bkTab);
    });
}
